import { render, staticRenderFns } from "./judicialAuctionList.vue?vue&type=template&id=5a616010&scoped=true"
import script from "./judicialAuctionList.vue?vue&type=script&lang=js"
export * from "./judicialAuctionList.vue?vue&type=script&lang=js"
import style0 from "./judicialAuctionList.vue?vue&type=style&index=0&id=5a616010&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a616010",
  null
  
)

export default component.exports